<script>
    import { doJSON, handleError } from "./lib";
    import { doUpload } from "./lib";
    import { push } from "svelte-spa-router";
    import Time from "svelte-time";
    export let params;

    let item = {
        'address': {},
        'requests': []
    };
    let name = 'vendor';
    let ui_name = 'Vendor';

    let submitted = false;
    let method = 'PUT';
    let url = '';
    let message = {};

    let files;

    async function init() {
        method = 'PUT';
        url = `/api/${name}`;

        if(params.id == 'new') {
            method = 'POST';
        } else {
            url += '/' + params.id;
            let [success, response] = await doJSON(url, false, 'GET');
            if(success) {
                item = response;
            }
        }
    }

    async function submit() {
        message = {};

        let [success, response] = await doJSON(url, item, method);
        if(success) {

            message = {
                'text': `The ${name} has been updated`,
                'class': 'success'
            }

            item = response;
            init();
        } else {
            await handleError(response, message);
            message = message;
        }
        document.getElementById('main').scrollTo({'top': 0, 'left': 0, 'behavior': 'smooth'});
    }

    async function upload() {
        let resp = await doUpload(files);
        if(resp.ok) {
            let data = await resp.json();
            item.documentation_path = data.filename;
            files = undefined;
        } else {
            message = {
                'text': 'There was an error uploading the file',
                'class': 'error'
            };
        }
    }

    init();
</script>

<h1>Edit { ui_name }</h1>
{#if message.text}
    <div class="msg {message.class}">{message.text}</div>
{/if}
<form class:submitted="{submitted}" on:submit|preventDefault="{submit}">
    <label>
        <span class="label">Approved</span>
        <select bind:value="{item.approved}">
            <option value={0}>No</option>
            <option value={1}>Yes</option>
        </select>
    </label>
    <label>
        <span class="label">Name</span>
        <input required bind:value="{item.name}" />
    </label>
    <label>
        <span class="label">FEIN {#if item.type == 'Individual/Sole Proprietor or Single-Member LLC'}(Please add dashes manually. 123-45-6789 or 12-345679){/if}</span>
        <input type="text" required bind:value="{item.fein}" />
    </label>

    <fieldset>
        <legend class="label">Vendor Organization Type</legend>

        <label class="radio">
            <input type="radio" name="vendor_type" required bind:group="{item.type}" value="Individual/Sole Proprietor or Single-Member LLC" />
            <span class="label">Individual/Sole Proprietor or Single-Member LLC</span>
        </label>

        <label class="radio">
            <input type="radio" name="vendor_type" required bind:group="{item.type}" value="Partnership" />
            <span class="label">Partnership</span>
        </label>

        <label class="radio">
            <input type="radio" name="vendor_type" required bind:group="{item.type}" value="Corporation" />
            <span class="label">Corporation</span>
        </label>

        <label class="radio">
            <input type="radio" name="vendor_type" required bind:group="{item.type}" value="Trust/Estate" />
            <span class="label">Trust/Estate</span>
        </label>

        <label class="radio">
            <input type="radio" name="vendor_type" required bind:group="{item.type}" value="Charity" />
            <span class="label">Other/501(c)(3)</span>
        </label>
    </fieldset>

    {#if item.type == 'Corporation'}

        <fieldset>
            <legend class="label">Is this entity an LLC?</legend>
            <label class="radio">
                <input type="radio" name="is_corporation" required bind:group="{item.is_corporation}" value={1} />
                <span class="label">Yes</span>
            </label>
            <label class="radio">
                <input type="radio" name="is_corporation" required bind:group="{item.is_corporation}" value={0} />
                <span class="label">No</span>
            </label>
        </fieldset>
    {/if} <!-- end item.type == 'Corporation' -->

    <label>
        <span class="label">W-9</span>
        {#if item.documentation_path}
            <p>
                <a target="_blank" href="/uploads/{item.documentation_path}">Click to view: {item.documentation_path}</a>
            </p>
            <button type="button" class="btn sm-btn" on:click="{() => { delete item.documentation_path; item = item;}}">Remove</button>
        {:else}
        <input accept=".jpg,.jpeg,.pdf,.doc.docx,.png" type="file" bind:files="{ files }" on:change="{() => {upload('status')}}" />
        {/if}
    </label>

    <label>
        <span class="label">Street Address</span>
        <input required bind:value="{item.address.address}" />
    </label>

    <label>
        <span class="label">City</span>
        <input required bind:value="{item.address.city}" />
    </label>

    <label>
        <span class="label">State</span>
        <select required bind:value="{item.address.state}">
            <option value=""></option>
            <option value="AL">Alabama</option> <option value="AK">Alaska</option> <option value="AS">American Samoa</option> <option value="AZ">Arizona</option> <option value="AR">Arkansas</option> <option value="CA">California</option> <option value="CO">Colorado</option> <option value="CT">Connecticut</option> <option value="DE">Delaware</option> <option value="DC">District of Columbia</option> <option value="FL">Florida</option> <option value="GA">Georgia</option> <option value="GU">Guam</option> <option value="HI">Hawaii</option> <option value="ID">Idaho</option> <option value="IL">Illinois</option> <option value="IN">Indiana</option> <option value="IA">Iowa</option> <option value="KS">Kansas</option> <option value="KY">Kentucky</option> <option value="LA">Louisiana</option> <option value="ME">Maine</option> <option value="MH">Marshall Islands</option> <option value="MD">Maryland</option> <option value="MA">Massachusetts</option> <option value="MI">Michigan</option> <option value="MN">Minnesota</option> <option value="MS">Mississippi</option> <option value="MO">Missouri</option> <option value="MT">Montana</option> <option value="NE">Nebraska</option> <option value="NV">Nevada</option> <option value="NH">New Hampshire</option> <option value="NJ">New Jersey</option> <option value="NM">New Mexico</option> <option value="NY">New York</option> <option value="NC">North Carolina</option> <option value="ND">North Dakota</option> <option value="OH">Ohio</option> <option value="OK">Oklahoma</option> <option value="OR">Oregon</option> <option value="PW">Palau</option> <option value="PA">Pennsylvania</option> <option value="PR">Puerto Rico</option> <option value="RI">Rhode Island</option> <option value="SC">South Carolina</option> <option value="SD">South Dakota</option> <option value="TN">Tennessee</option> <option value="TX">Texas</option> <option value="UT">Utah</option> <option value="VT">Vermont</option> <option value="VI">Virgin Islands</option> <option value="VA">Virginia</option> <option value="WA">Washington</option> <option value="WV">West Virginia</option> <option value="WI">Wisconsin</option> <option value="WY">Wyoming</option>
        </select>
    </label>

    <label>
        <span class="label">Zip</span>
        <input required bind:value="{item.address.zip}" />
    </label>


    <label>
        <span class="label">Notes</span>
        <textarea bind:value="{item.notes}" placeholder=""></textarea>
    </label>

    {#if item.requests && item.requests.length > 0}
    <h2>Requests</h2>
    <table class="table click-table">
        <tr>
            <th>Dealer</th>
            <th>Date</th>
            <th>Event Date</th>
            <th>Description</th>
            <th>Amount</th>
            <th>Status</th>
        </tr>
    {#each item.requests as request }
        <tr class="tbody" on:click="{async () => { await push(`/request/${request.id}`) }}">
            <td>{request.dealer.name }</td>
            <td><Time format="YYYY-MM-DD" timestamp={request.createdAt}></Time></td>
            <td>{request.event_date}</td>
            <td>{request.description}</td>
            <td>{request.amount}</td>
            <td>{request.status}</td>
        </tr>
    {/each}
    </table>
    {/if}

    <p><button on:click="{() => { submitted = true}}" class="btn u-w100">SUBMIT</button></p>
</form>
